import { useFormContext } from 'react-hook-form';

import { SESSION_ATTENDANCE_STATUS } from 'features/sessions/config';
import { SessionType } from 'features/sessions/config/types';
import { useSessionsQueryActions } from 'features/sessions/hooks/useSessionsQueryActions';

export const useSessionPageCancelSessionMutateOptions = (sessionId: string) => {
  const { getSessionById, updateSession } = useSessionsQueryActions();
  const { setValue } = useFormContext();

  const onMutate = ({ reason }: { reason: string }) => {
    const oldSession = getSessionById(sessionId);

    setValue('attendance', SESSION_ATTENDANCE_STATUS.CANCELED);
    setValue('attendanceNote', reason);

    updateSession(sessionId, {
      attendance: SESSION_ATTENDANCE_STATUS.CANCELED,
    });

    return { oldSession };
  };

  const onError = (
    err: Error,
    _: any,
    context: { oldSession: SessionType }
  ) => {
    setValue('attendance', context.oldSession.attendance);
    updateSession(sessionId, {
      attendance: context.oldSession.attendance,
    });
  };

  return {
    onMutate,
    onError,
  };
};
